/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */

export const ERROR_TITLE_DEFAULT = 'Unable to load page';

export const ERROR_BODY_DEFAULT =
  'Why is this happening? You may have many login pages opened, tapped the back button or refreshed during login. It could also be that your browser cookies are disabled. Try logging in again.';

export const ERROR_BODY_NOSCRIPT =
  'We are sorry, but this application does not work properly without JavaScript enabled in your browser.';

export const ERROR_FROM_AUTH0 =
  'You may have pressed the back button, refreshed during login, opened too many login dialogs, or there is some issue with cookies, since we couldn&#39;t find your session. Try logging in again from the application and if the problem persists please contact the administrator.';

export const ERROR_INVALID_REQUEST = 'Invalid Request.';
